import { FormModel } from '../core/form-model.class';
import { FrontCreateTagDto } from './create-tag.dto';

export class TagFormModel extends FormModel(FrontCreateTagDto) {
  public labels: any = {
    label: 'Libellé',
    agencyId: 'Agence',
  };
}
